import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "station-form-category-container text-left",
  "data-testid": "sector-specialty-fields"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "station-form-category-title" }, "Setor e especialidade (opcional)"),
  /*#__PURE__*/_createElementVNode("span", { class: "rounded-full bg-primary5 px-2 text-[10px] font-bold text-primary30" }, "NOVO")
], -1)
const _hoisted_3 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_4 = { class: "mt-3 grid grid-cols-1 gap-4 md:grid-cols-2" }
const _hoisted_5 = {
  key: 0,
  class: "mt-1 text-xs text-gray-500",
  "data-testid": "sector-field-hint"
}
const _hoisted_6 = {
  key: 0,
  class: "mt-1 text-xs text-gray-500",
  "data-testid": "specialty-field-hint"
}
const _hoisted_7 = {
  key: 0,
  class: "mt-3 rounded bg-gray-50 px-3 py-2 text-sm text-gray-700",
  "data-testid": "sector-specialty-summary"
}

import SectorCombobox from './SectorCombobox.vue'
import SpecialtyCombobox from './SpecialtyCombobox.vue'
import type { StationSectorRef } from '@/Network/Types/Responses/StationResponses'
import type { SpecialtySelection } from '@/utils/sectorSpecialty'


export default /*#__PURE__*/_defineComponent({
  __name: 'SectorSpecialtyFields',
  props: {
    healthUnitId: {},
    companyId: {},
    sector: {},
    specialty: {},
    description: {},
    sectorHint: { default: null },
    specialtyHint: { default: null },
    summary: { default: null },
    disabled: { type: Boolean, default: false },
    officialOnly: { type: Boolean, default: false }
  },
  emits: ["update:sector", "update:specialty"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.description), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createVNode(SectorCombobox, {
          "model-value": _ctx.sector,
          "health-unit-id": _ctx.healthUnitId,
          disabled: _ctx.disabled,
          "test-id": "sector-field",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:sector', $event)))
        }, null, 8, ["model-value", "health-unit-id", "disabled"]),
        (_ctx.sectorHint)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.sectorHint), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createVNode(SpecialtyCombobox, {
          "model-value": _ctx.specialty,
          "company-id": _ctx.companyId,
          "official-only": _ctx.officialOnly,
          disabled: _ctx.disabled,
          "test-id": "specialty-field",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('update:specialty', $event)))
        }, null, 8, ["model-value", "company-id", "official-only", "disabled"]),
        (_ctx.specialtyHint)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.specialtyHint), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.summary)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.summary), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})